import {Flex, Input, Segmented, Space} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faBarsStaggered, faNoteSticky, faTableColumns
} from "@fortawesome/free-solid-svg-icons";

import React, {useEffect} from "react";
import {PlotActDetails} from "./PlotActDetails";
import {PlotDetails} from "./PlotDetails";
import {PlotChapterDetails} from "./PlotChapterDetails";
import {PlotSceneDetails} from "./PlotSceneDetails";
import Title from "antd/es/typography/Title";
import {PlotShotDetails} from "./PlotShotDetails";
import {generateTitlePrompt} from "./prompts/PlotPrompts";
import {PlotList} from "./list/PlotList";
import {PlotSectionDetails} from "./PlotSectionDetails";
import {DebounceInput} from "../../../../../../components/DebounceInput";
import {useAppDispatch, useAppSelector} from "../../../../../../feature/tools";
import {updateTitle} from "../../../../../../feature/project/draftSlice";
import {GenButton} from "../../../../../../ai/components/GenButton";
import {aiChainPrompt} from "../../../../../../ai/Prompt";
import {ModelsMenu} from "../../../../../../ai/components/ModelsMenu";

export const PlotContent = () => {
    const dispatch = useAppDispatch()
    const draft = useAppSelector(state => state.draftSlice.draft)
    const [data, setData] = React.useState<{
        data: any,
        type: 'act' | 'chapter' | 'scene' | 'story' | 'section'
    } | undefined>(undefined)
    const [flow, setFlow] = React.useState(false)
    const [edit, setEdit] = React.useState(true)

    return (
        <Flex gap={10} style={{width: "100%", height: "100%"}} align={'start'} className={"draft-details"}>

            <PlotList
                story={draft.story}
                data={data}
                onItemSelected={(item) => {
                    setData(item)
                }}
            />
            <Flex vertical={true} gap={10} style={{width: "100%", height: "100%", minWidth: 0}}>
                <Flex gap={10} justify={'space-between'} align={'center'}>
                    <Space><Title level={4} style={{margin: 0}}> {data?.type == 'story' ? <DebounceInput
                        style={{fontWeight: 'bold', fontSize: 16}}
                        value={draft.story.title ?? 'Untitled'}
                        onChange={(text) => {
                            dispatch(updateTitle({title: text}))
                        }}
                    /> : (draft.story.title ?? 'Untitled')}</Title>
                        {data?.type == 'story' ?
                            <GenButton mode={'icon'} actions={[{
                                key: "1", title: "Generate", action: async (model: string, projectId: string) => {
                                    let data = await aiChainPrompt({
                                        projectId: projectId ?? '',
                                        prompt: generateTitlePrompt({
                                            genres: draft.properties.genre,
                                            synopsis: draft.properties.synopsis,
                                        }),
                                        model: model,
                                        type: 'json'
                                    })
                                    dispatch(updateTitle({
                                        title: data.data.title
                                    }))
                                }
                            }]}/> : ''}
                    </Space>

                    <Space>
                        <ModelsMenu/>
                        <Segmented
                            value={edit && !flow ? 'edit' : flow && !edit ? 'flow' : 'split'}
                            options={
                                [
                                    {
                                        label: <FontAwesomeIcon icon={faNoteSticky}/>,
                                        value: 'edit',
                                    },
                                    {
                                        label: <FontAwesomeIcon icon={faBarsStaggered}/>,
                                        value: 'flow',
                                    },
                                    {
                                        label: <FontAwesomeIcon icon={faTableColumns}/>,
                                        value: 'split',
                                    }
                                ]
                            }
                            onChange={(value) => {
                                if (value == 'edit') {
                                    setFlow(false)
                                    setEdit(true)
                                }
                                if (value == 'flow') {
                                    setFlow(true)
                                    setEdit(false)
                                }
                                if (value == 'split') {
                                    setFlow(true)
                                    setEdit(true)
                                }
                            }}
                        />
                    </Space>
                </Flex>
                <Flex gap={10} style={{width: "100%", height: "100%", minHeight: 0}}>
                    {edit ?
                        <div style={{height: "100%", width: flow ? "calc(50% - 5px)" : "100%"}}>
                            {data && data.type == 'story' ? <PlotDetails/> : ''}
                            {data && data.type == 'act' ? <PlotActDetails act={data.data}/> : ''}
                            {data && data.type == 'chapter' ? <PlotChapterDetails chapter={data.data}/> : ''}
                            {data && data.type == 'section' ? <PlotSectionDetails section={data.data}/> : ''}
                            {data && data.type == 'scene' ? <PlotSceneDetails scene={data.data}/> : ''}
                        </div> : ''}
                    {flow ?
                        <div
                            style={{
                                width: edit ? "calc(50% - 5px)" : "100%"
                            }}>
                            <Flex
                                className={'draft-flow'}
                                vertical={true}
                                gap={10}
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    overflowY: 'auto',
                                    scrollbarWidth: 'none'
                                }}>
                                {
                                    draft.story.acts?.flatMap(a => a.chapters ?? [])?.flatMap(c => c.sections ?? [])?.flatMap(s => s?.scenes ?? [])?.flatMap((s) => s.shots ?? [])?.map(item => {
                                        return <PlotShotDetails key={item.id} shot={item} id={`shot-${item.id}`}/>
                                    })
                                }
                            </Flex>
                        </div>
                        : ''}
                </Flex>
            </Flex>
        </Flex>
    )
}